
<template>
	<div>
		<a-form-model :model="searchData" style="display:flex;flex-wrap: wrap" layout="inline">
			<a-form-model-item >
               <a-input style="width:150px"  v-model="searchData.name" allowClear  placeholder="请输入合同名称"/>
           </a-form-model-item> 
           <a-form-model-item >
               <a-input style="width:150px" v-model="searchData.yi" allowClear  placeholder="乙方姓名"/>
           </a-form-model-item> 
           <a-form-model-item >
               <a-input style="width:150px" v-model="searchData.yiPhone" allowClear  placeholder="乙方电话"/>
           </a-form-model-item>
           <a-form-model-item >
               <a-input style="width:150px" v-model="searchData.yiIdCard" allowClear  placeholder="乙方身份证号码"/>
           </a-form-model-item>
           <a-form-model-item >
               <a-input style="width:150px" v-model="searchData.yiBanZhu" allowClear  placeholder="乙方所在班组"/>
           </a-form-model-item>
           <a-form-model-item >
               <a-input style="width:150px" v-model="searchData.groupidcard" allowClear  placeholder="乙方班组身份证"/>
           </a-form-model-item>
			<a-form-model-item >
               <a-select style="width:150px" v-model="searchData.yiWorkPlace" allowClear  placeholder="乙方所在工地" @change="workplacechange" >
				   <a-select-option v-for="item in workplaceArray" :key="item.id" :value="item.id" :text="item.name">{{item.name}}</a-select-option>
			   </a-select>
           </a-form-model-item> 
		   <a-form-model-item >
                <a-select placeholder="合同类型" style="width:150px" v-model="searchData.type" allowClear>
                    <a-select-option  v-for="item in contractTypes"  :value="item.value" :key="item.value" >{{ item.title }}</a-select-option>
				</a-select>
		   </a-form-model-item>
		   <a-form-model-item>
                <a-select placeholder="是否拨款" style="width:150px" v-model="searchData.isMoneyGive" allowClear>
                    <a-select-option   value="0" :key="0">未拨款</a-select-option>
                    <a-select-option   value="1" :key="1" >已拨款</a-select-option>
				</a-select>
		   </a-form-model-item>
		   <a-form-model-item>
                <a-select placeholder="是否离场" style="width:150px" v-model="searchData.yiOuttime" allowClear>
                    <a-select-option   :value="1" :key="1">在场</a-select-option>
                    <a-select-option   :value="2" :key="2" >离场</a-select-option>
				</a-select>
		   </a-form-model-item>
		   <a-form-model-item>
                <a-select placeholder="查看类型" style="width:150px" v-model="searchData.confirm" allowClear>
                    <a-select-option   value="0" key="0">未确认</a-select-option>
                    <a-select-option   value="1" key="1" >已确认</a-select-option>
				</a-select>
		   </a-form-model-item>
		   <a-form-model-item>
			   <a-date-picker style="width:150px" v-model="searchData.tt1" allowClear placeholder="开始时间" ></a-date-picker>
		   </a-form-model-item>
		   <a-form-model-item>
			   <a-date-picker style="width:150px" v-model="searchData.tt2" allowClear placeholder="结束时间" ></a-date-picker>
		   </a-form-model-item>
			<slot name="btns"></slot>
		</a-form-model>
	</div>
</template>

<script>
import moment from 'moment';
import {getAll} from "@/api/workplace.js"
import {contractTypes} from '@/components/commendata'
function getSearchParm(obj){
    return new Proxy(obj,{
        get(target,key){
            if(target[key] == ""||target==null){
                return undefined
            }
		    if((key == "tt1"||key=="tt2") && moment.isMoment(target[key])){
				return target[key].format("YYYY-MM-DD"); 
		    }
			return target[key]
	    }
    })
}
let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)
let tt1 = localStorage.getItem("date1"),tt2=localStorage.getItem("date2")
if(tt1){tt1 = tt1.substring(0,7)}
if(tt2){tt2 = tt2.substring(0,7)}
export default {
	data(){
		return {
			searchData:getSearchParm({
				name:"",
				yi:"",
				yiPhone:"",
				yiWorkPlace:"",
				yiBanZhu:"",
				type:undefined,
				isMoneyGive:undefined,
				yiOuttime:undefined,
				confirm:undefined,
				tt1:undefined,
				tt2:undefined,
				groupidcard:""
			}),
			workplaceArray:[],
			contractTypes,
		}
	},
	methods:{
		getformdata(){
			return this.searchData
		},
		getWorkPlaceArray(){
			getAll({cmpid:user.cmpid}).then(ret=>{
				if(ret.code == 0) {
					let {data} = ret
					this.workplaceArray = data
				}
			})
		},
		workplacechange(v,e){
			let {data:{attrs:{text}}} = e
			this.searchData = {...this.searchData,yiWorkPlace:text}
		},
	},
	mounted(){
		this.getWorkPlaceArray()
	}	
}
</script>

